import { useLayoutStore } from '@stores';

/**
 * Hook to update the organization logo.
 * Migrated from Context API to Zustand.
 *
 * @deprecated Consider using useLayoutStore directly for new components
 */
export function useLogoUpdate(): {
    logoOrgId: string | undefined;
    setLogoOrgId: (logoOrgId: string | undefined) => void;
} {
    const logoOrgId = useLayoutStore((state) => state.logoOrgId);
    const setLogoOrgId = useLayoutStore((state) => state.setLogoOrgId);

    return { logoOrgId, setLogoOrgId };
}

/**
 * @deprecated LogoUpdateProvider is no longer needed.
 * State is now managed with Zustand (useLayoutStore).
 * Kept temporarily for backwards compatibility.
 */
export function LogoUpdateProvider({
    children,
}: {
    children: React.ReactNode;
}): React.JSX.Element {
    // The Provider is no longer needed because Zustand handles state globally.
    // Simply renders children directly.
    return <>{children}</>;
}

// Re-export for compatibility (no longer used)
export const LogoUpdateContext = null;
